import { FC } from 'react'
import { Colors } from 'src/components/theme'
import { WidgetCard } from 'src/v2/components/widget-card'
import { ParcelPropertyOwnersContent } from 'src/v2/views/owner-reveal/insights/parcel-insights/property-records/possible-owners/content'

export const ParcelPossibleOwnersWidget: FC = () => {
  return (
    <WidgetCard
      id="possible-owners"
      title="Possible Owners"
      headerBgColor={Colors.primaryGreen700}
      headerTextColor={Colors.textWhite}
      sections={[
        {
          content: <ParcelPropertyOwnersContent />,
        },
      ]}
    />
  )
}
